<script lang="ts">
	import type { Review } from "../../data/homepageData.js";
	import Formatted from "./Formatted.svelte";
	import Media from "./Media.svelte";
	import StructuredData from "./StructuredData.svelte";

	const { review }: { review: Review } = $props();
</script>

<StructuredData
	data={{
		"@type": "Review",
		author: {
			"@type": "Person",
			name: review.name,
		},
		text: review.text,
	}}
/>

<div class="basis-[18rem] md:basis-[28rem] lg:basis-[35rem] xl:basis-[38.6875rem] flex-shrink-0 px-2 h-full">
	<article
		class="flex flex-col md:flex-row items-stretch h-full p-4 md:p-6 md:pr-8 gap-4 md:gap-6 bg-ivory-100 border border-ivory-300 rounded-[2rem] md:rounded-[4rem] lg:rounded-[5rem] xl:rounded-[6rem]"
	>
		{#if review.photo}
			<div
				class="w-32 h-32 md:w-40 md:h-40 xl:w-56 xl:h-56 flex-shrink-0 overflow-hidden rounded-full self-center md:self-center"
			>
				<Media
					source={{ src: review.photo, type: "image" }}
					alt={review.name}
					width={224}
					height={224}
					sourcesets={{}}
					class="w-full h-full object-cover"
				/>
			</div>
		{:else}
			<div
				class="w-32 h-32 md:w-40 md:h-40 xl:w-56 xl:h-56 flex-shrink-0 flex items-center justify-center rounded-full bg-hazelnut-400/10 self-center md:self-center"
			>
				<span class="text-2xl md:text-3xl xl:text-4xl font-bold text-hazelnut-500">
					{review.name.charAt(0).toUpperCase()}
				</span>
			</div>
		{/if}

		<div class="flex flex-col justify-center gap-3 md:gap-4 flex-1 min-w-0 overflow-hidden">
			<div class="flex flex-col gap-0">
				<span class="font-bold text-base md:text-md leading-[1.3] md:leading-[1.625rem] text-[#262626]">
					{review.name}
				</span>
			</div>

			<p
				class="text-sm md:text-[.85rem] leading-[140%] text-[#7D7D7D] font-light line-clamp-[6] md:line-clamp-[8] overflow-hidden"
			>
				<Formatted text={review.text} />
			</p>
		</div>
	</article>
</div>
